export {
  default as ErrorDataUnavailable,
  type ErrorDataUnavailableProps
} from './ErrorDataUnavailable'
